import React from 'react';
import css from './LocationInputFormField.module.css';
import { Field } from 'react-final-form';
import { LocationAutocompleteInput } from '../../../../components';
const identity = v => v;

const LocationInputFormField = ({ label, placeholder }) => {
  return (
    <>
      {label && <label className={css.label}>{label}</label>}
      <Field
        name="location"
        format={identity}
        render={({ input, meta }) => {
          const { onChange, ...restInput } = input;

          // Merge the standard onChange function with custom behaviur. A better solution would
          // be to use the FormSpy component from Final Form and pass this.onChange to the
          // onChange prop but that breaks due to insufficient subscription handling.
          // See: https://github.com/final-form/react-final-form/issues/159
          const searchOnChange = value => {
            onChange(value);
          };

          const searchInput = { ...restInput, onChange: searchOnChange };
          return (
            <LocationAutocompleteInput
              placeholder={placeholder}
              iconClassName={css.searchInputIcon}
              inputClassName={css.searchInput}
              predictionsClassName={css.searchPredictions}
              input={searchInput}
              meta={meta}
              shouldHideSearchIcon
            />
          );
        }}
      />
    </>
  );
};

export default LocationInputFormField;
